'use client';

/** @jsxImportSource @emotion/react */
import { Container, FlexLayout, FlexItem, Logo, Typography } from '@wci-tech/core-ui';
import { useTranslations } from 'next-intl';
import { useStyles } from './Companies.styles';

import { useThemeMode } from '@/context';

const Companies = () => {
  const { isDark } = useThemeMode();
  const styles = useStyles();
  const t = useTranslations('Companies');

  const companyLogos = [
    {
      id: 'iwc',
      src: isDark ? '/svgs/iwcDark.svg' : '/svgs/iwcLight.svg',
      alt: t('logos.iwc'),
      width: 110,
    },
    {
      id: 'rapipay',
      src: isDark ? '/svgs/rapiPayDark.svg' : '/svgs/rapiPayLight.svg',
      alt: t('logos.rapipay'),
      width: 145,
    },
    {
      id: 'vancleef',
      src: isDark ? '/svgs/vanCADark.svg' : '/svgs/vanCALight.svg',
      alt: t('logos.vancleef'),
      width: 305,
    },
    // {
    //   id: 'blueoptima',
    //   src: isDark ? '/svgs/blueOptimaDark.svg' : '/svgs/blueOptimaLight.svg',
    //   alt: t('logos.blueoptima'),
    //   width: 212,
    // },
  ];

  return (
    <section css={styles.wrapper}>
      <Container css={styles.container}>
        <FlexLayout direction="column" alignItems="center" gap={{ default: 36, md: 24, lg: 40 }}>
          {/* Section Header */}
          <FlexItem>
            <Typography variant="h2" customStyles={styles.sectionTitle}>
              {t('sectionTitle')}
            </Typography>
          </FlexItem>
          {/** logo section */}
          <FlexItem>
            <FlexLayout
              direction={{ default: 'column', md: 'row', lg: 'row' }}
              alignItems="center"
              gap={{ default: '8px', md: '16px', lg: '48px' }}
            >
              {companyLogos.map((logo) => (
                <FlexItem key={logo.id} css={styles.logoItem}>
                  <Logo
                    key={`${logo.id}-${isDark}`}
                    src={logo.src}
                    decorative={false}
                    alt={logo.alt}
                    width={logo.width}
                  />
                </FlexItem>
              ))}
            </FlexLayout>
          </FlexItem>
        </FlexLayout>
      </Container>
    </section>
  );
};

export default Companies;
